// Helpers puros usados pelos sub-componentes de Atividades.

/** Atividade do comercial ligada a um NEGÓCIO: pede ao pipeline para abri-lo
 *  ao chegar (o mesmo recado dos follow-ups — `abrir_proposta_id`). Devolve se
 *  havia negócio a abrir; quem chama navega para /comercial/pipeline. */
export function pedirAberturaDoNegocio(origemTipo: string, origemId: string | null): boolean {
  if (!['proposta', 'negocio'].includes(origemTipo) || !/^\d+$/.test(String(origemId || ''))) return false;
  try { sessionStorage.setItem('abrir_proposta_id', String(origemId)); } catch { /* sem storage: abre o pipeline */ }
  return true;
}

/** Extrai @emails de um texto livre. Retorna lista única em minúsculas. */
export function extrairMencoes(t: string): string[] {
  const re = /@([a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
  const set = new Set<string>();
  let m;
  while ((m = re.exec(t)) !== null) set.add(m[1].toLowerCase());
  return Array.from(set);
}
